module.exports = __webpack_public_path__ + "static/media/sphingonotus_caerulans.a4142cfc.jpg";